import Grid from "@mui/material/Grid";
import Logo from "../../../../assets/images/logo.png";
import {useEffect, useRef, useState} from "react";
import {Event} from "../../../../data/models/bracket_api/Event";
import {Bracket} from "../../../../data/models/bracket_api/Bracket";
import {FourWideResult} from "../../../../data/models/bracket_api/FourWideResult";
import {RaceClass} from "../../../../data/models/bracket_api/RaceClass";
import Box from "@mui/material/Box";
import ConfigBracketFourWide from "./ConfigBracketFourWide";

type TwoWideConfigBracketContainerProModProps = {
    event: Event,
    brackets: Bracket[],
    results: FourWideResult[],
    updateResult: (result: FourWideResult) => void,
}

export default function FourWideConfigBracketContainerProMod(props: Readonly<TwoWideConfigBracketContainerProModProps>) {
    const containerRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState<boolean>(true);

    useEffect(() => {
        const container = containerRef.current;

        let isMouseDown = false;
        let startX: number;
        let scrollLeft: number;

        const element = containerRef.current;

        if (element) {
            setIsOverflowing(element.scrollWidth > element.clientWidth);
        }

        const handleMouseDown = (event: MouseEvent) => {
            isMouseDown = true;
            startX = event.pageX - container!.offsetLeft;
            scrollLeft = container!.scrollLeft;
        };

        const handleMouseUp = () => {
            isMouseDown = false;
        };

        const handleMouseMove = (event: MouseEvent) => {
            if (!isMouseDown) return;
            event.preventDefault();
            const x = event.pageX - container!.offsetLeft;
            const walk = (x - startX); // Adjust the scroll speed here
            container!.scrollLeft = scrollLeft - walk;
        };

        const handleResize = () => {
            const element = containerRef.current;

            if (element) {
                setIsOverflowing(element.scrollWidth > element.clientWidth);
            }
        }

        window.addEventListener('resize', handleResize);
        container!.addEventListener('mousedown', handleMouseDown);
        container!.addEventListener('mouseup', handleMouseUp);
        container!.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('resize', handleResize);
            container!.removeEventListener('mousedown', handleMouseDown);
            container!.removeEventListener('mouseup', handleMouseUp);
            container!.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    let proModBracket = props.brackets.find((bracket) => {
        return bracket.race_class === RaceClass.PRO_MOD;
    })
    let proModResults = props.results.filter((result) => {
        return result.bracket.race_class === RaceClass.PRO_MOD;
    });

    return (
        <Grid
            container
            ref={containerRef}
            sx={{
                width: 'fit-content',
                overflow: 'auto',
                cursor: isOverflowing ? 'grab' : 'default',
                userSelect: 'none',
            }}
        >

            <Grid container sx={{
                display: 'flex',
                flexDirection: "column",
                justifyContent: "space-evenly",
                alignItems: "center",
                alignContent: "center",
                height: 'fit-content',
                width: 'fit-content',
            }}>
                <Grid container sx={{
                    marginY: 1,
                    display: 'flex',
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    width: 'fit-content',
                }}>
                    {proModBracket ?
                        <ConfigBracketFourWide race_class={RaceClass.PRO_MOD} updateResult={props.updateResult} bracket={proModBracket} results={proModResults}/> :
                        <Box sx={{visibility: "hidden"}}>
                            <ConfigBracketFourWide race_class={RaceClass.PRO_MOD} updateResult={props.updateResult}/>
                        </Box>
                    }
                </Grid>
            </Grid>
        </Grid>
    );
}